(function () {
  const SELECTOR = '.js-live-price';

  function formatMoney(cents, format) {
    const formatString = format || window.shopMoneyFormat || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    const amountNoDecimals = Math.round(cents / 100).toString();
    const amountWithComma = amount.replace('.', ',');
    const amountNoDecimalsWithComma = amountNoDecimals;

    return formatString
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimalsWithComma)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function getVariant(product, variantId) {
    if (!product?.variants?.length) return null;

    if (variantId) {
      const matchedVariant = product.variants.find((variant) => String(variant.id) === String(variantId));
      if (matchedVariant) return matchedVariant;
    }

    return product.variants.find((variant) => variant.available) || product.variants[0];
  }

  function clearPrice(element) {
    element.textContent = '';
    element.classList.remove('oz-price-sale');
    element.closest('.oz-live-price')?.classList.add('oz-live-price--empty');
  }

  function renderPrice(element, product) {
    const variant = getVariant(product, element.dataset.variantId);

    if (!variant) {
      clearPrice(element);
      return;
    }

    const cell = element.closest('.oz-live-price') || element.parentElement;
    const formattedPrice = formatMoney(variant.price);
    const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    const showCompare = element.dataset.showCompare !== 'false';

    if (onSale && showCompare) {
      let compareElement = cell.querySelector('.oz-price-was');

      if (!compareElement) {
        compareElement = document.createElement('span');
        compareElement.className = 'oz-price-was';
        element.parentElement.insertBefore(compareElement, element);
      }

      compareElement.textContent = formatMoney(variant.compare_at_price);
      element.textContent = formattedPrice;
      element.classList.add('oz-price-sale');
    } else {
      element.textContent = formattedPrice;
      element.classList.remove('oz-price-sale');

      const compareElement = cell?.querySelector('.oz-price-was');
      if (compareElement && cell?.classList.contains('oz-live-price')) {
        compareElement.remove();
      }
    }

    cell?.classList.remove('oz-live-price--empty');
  }

  async function fetchProduct(handle) {
    try {
      const response = await fetch(`/products/${encodeURIComponent(handle)}.js`);

      if (!response.ok) return null;

      return await response.json();
    } catch (error) {
      return null;
    }
  }

  async function initLiveBlogPrices() {
    const elements = document.querySelectorAll(SELECTOR);

    if (!elements.length) return;

    const handles = [...new Set([...elements].map((element) => element.dataset.handle).filter(Boolean))];
    const products = {};

    await Promise.all(
      handles.map(async (handle) => {
        products[handle] = await fetchProduct(handle);
      })
    );

    elements.forEach((element) => {
      const product = products[element.dataset.handle];

      if (!product) {
        clearPrice(element);
        return;
      }

      renderPrice(element, product);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLiveBlogPrices);
  } else {
    initLiveBlogPrices();
  }
})();
